import styles from './Dialog.mobile.module.css';
import { FaXmark } from 'react-icons/fa6';
import type DialogProperties from '../Dialog.properties.ts';
import type { CSSProperties } from 'react';

export default function DialogMobileView(props: DialogProperties) {
  return (
    <div
      onClick={() => {
        if (props.onBackdrop) {
          props.onBackdrop();
        }
      }}
      className={styles.overlay}
      style={
        {
          '--index': props.moveToFront ? 20001 : 20000,
        } as CSSProperties
      }
    >
      <div className={styles.dialog} onClick={(event) => event.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.headerContent}>{props.header}</div>
          <div className={styles.closeContent}>
            <FaXmark
              className={styles.closeIcon}
              onClick={() => (props.onBackdrop ? props.onBackdrop() : undefined)}
            />
          </div>
        </div>
        {props.children}
      </div>
    </div>
  );
}
